import css from 'styled-jsx/css';
import { zIndex, common } from '../../theme/theme';

const style = css.global`
  .add-profile-wrapper {
    z-index: ${zIndex.allAroundModal};
  }
  .add-profile-wrapper .ant-modal-header {
    padding: 32px;
    border-bottom: 0;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .add-profile-wrapper .ant-modal-title {
    font-size: 24px;
  }
  .add-profile-wrapper .ant-modal-body {
    padding: 15px;
    padding-top: 0;
  }
  .add-profile-wrapper .ant-modal-close {
    width: 50px;
    height: 50px;
    color: black;
  }
  .add-profile-contents {
    width: 400px;
  }
  .add-profile-subtitle {
    font-size: 15px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    padding: 0 17px;
  }
  .add-profile-input-container {
    padding: 16px;
  }
  .button-container {
    padding: 8px 16px 8px 16px;
  }
  .add-profile-wrapper :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
  }
  .add-profile-wrapper :global(.submit-button:hover) {
    ${common.button}
    ${common.submitButton}
  }
  .error {
    color: red;
    font-size: 11px;
    margin-bottom: 0;
    margin: 4px;
  }
`;

export default style;
